"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const abstract_filter_item_1 = require("./abstract-filter-item");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
class NumberFilterItem extends abstract_filter_item_1.AbstractFilterItem {
    constructor(id, label, onValueChange, defaultValues) {
        super(id, label, onValueChange);
        this.defaultValues = defaultValues;
        this._byCategoryId = this.defaultValues ? this.defaultValues.byCategoryId : null;
    }
    get valueFrom() {
        return this._valueFrom;
    }
    set valueFrom(value) {
        if (value !== this._valueFrom) {
            this._valueFrom = value;
            this.validate() && this.onFilterItemChange();
        }
    }
    get valueTo() {
        return this._valueTo;
    }
    set valueTo(value) {
        if (value !== this._valueTo) {
            this._valueTo = value;
            this.validate() && this.onFilterItemChange();
        }
    }
    get byCategoryId() {
        return this._byCategoryId;
    }
    set byCategoryId(value) {
        this._byCategoryId = value;
        this.onFilterItemChange();
    }
    validate() {
        const isValid = (this.valueFrom != null && this.valueTo != null && this.valueFrom <= this.valueTo)
            || (this.valueFrom == null || this.valueTo == null);
        isValid ? this.validationMessage = '' : this.validationMessage = this.NUMBER_RANGE_VALIDATION_MESSAGE;
        return isValid;
    }
    getFilterTreeDto() {
        if (this.valueFrom == null && this.valueTo == null) {
            return null;
        }
        else if (this.valueFrom != null && this.valueTo != null) {
            const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
            filterBuilder.filterByMeasure(this.id).between(this.valueFrom, this.valueTo, null, this.byCategoryId);
            return filterBuilder.build();
        }
        else if (this.valueFrom != null) {
            const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
            filterBuilder.filterByMeasure(this.id).greaterThanOrEqual(this.valueFrom, null, this.byCategoryId);
            return filterBuilder.build();
        }
        else if (this.valueTo != null) {
            const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
            filterBuilder.filterByMeasure(this.id).lessThanOrEqual(this.valueTo, null, this.byCategoryId);
            return filterBuilder.build();
        }
    }
    getDefaultValue() {
        return {
            byCategoryId: this._byCategoryId
        };
    }
}
exports.NumberFilterItem = NumberFilterItem;
//# sourceMappingURL=number-filter-item.js.map